import * as React from "react";
type Props = {
  className?: string,
};
function SvgMinus({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-minus"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 11V13H5V11H19Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgMinus;
